import React from 'react'

const MPROToken: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Token_Signet 1" clipPath="url(#clip0_697_63438)">
        <g id="Layer 1">
          <g id="Group">
            <path
              id="Vector"
              d="M24 12C24 13.6197 23.6835 15.1924 23.0563 16.6714C22.4526 18.0996 21.5871 19.3833 20.4852 20.4852C19.3833 21.5871 18.0996 22.4526 16.6714 23.0563C15.1924 23.6815 13.6216 24 12 24C10.3784 24 8.80755 23.6835 7.32856 23.0563C5.90036 22.4526 4.61674 21.5871 3.51482 20.4852C2.41289 19.3833 1.54738 18.0996 0.943667 16.6714C0.318463 15.1924 0 13.6216 0 12C0 10.3784 0.316509 8.80755 0.943667 7.32856C1.54738 5.90036 2.41289 4.61674 3.51482 3.51482C4.61674 2.41289 5.90036 1.54738 7.32856 0.943667C8.80755 0.316509 10.3803 0 12 0C13.6197 0 15.1924 0.316509 16.6714 0.943667C18.0996 1.54738 19.3833 2.41289 20.4852 3.51482C21.5871 4.61674 22.4526 5.90036 23.0563 7.32856C23.6815 8.80755 24 10.3784 24 12Z"
              fill="black"
            />
            <path
              id="Vector_2"
              d="M20.614 9.80569V14.1841L17.5192 17.2788H13.1409L8.71756 12.8536L9.56744 12.0037L13.6391 16.0792H17.0249L19.4183 13.6859V10.3L15.8351 6.7168H17.529L20.614 9.80374V9.80569ZM10.8686 6.71875H6.47269L3.38574 9.80569V14.1841L6.4805 17.2788H8.17441L4.5834 13.6878V10.3019L6.97675 7.90859H10.3626L14.4401 11.9861L15.2881 11.1382L10.8686 6.71875ZM14.2213 6.71875H12.5547L17.0972 11.2612V12.7266L16.0617 13.7621H14.5964L9.88981 9.04763H7.44957L5.72439 10.7728V13.2131L9.78822 17.2769H11.4548L6.90251 12.7246V11.2593L7.93801 10.2238H9.40333L14.1099 14.9382H16.5502L18.2754 13.2131V10.7728L14.2213 6.71875Z"
              fill="url(#paint0_linear_697_63438)"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_697_63438"
          x1="4.82176"
          y1="16.4817"
          x2="19.1799"
          y2="7.51002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF029A" />
          <stop offset="0.12" stopColor="#E310B3" />
          <stop offset="0.49" stopColor="#9239FF" />
          <stop offset="0.56" stopColor="#7E53FF" />
          <stop offset="0.77" stopColor="#3CA9FF" />
          <stop offset="0.93" stopColor="#12DFFF" />
          <stop offset="1" stopColor="#03F5FF" />
        </linearGradient>
        <clipPath id="clip0_697_63438">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MPROToken
